// extracted by mini-css-extract-plugin
export default {"courseDetails":"overview_courseDetails__12VsK","item":"overview_item__i+OBE"};